<template>
  <button class="btn" :disabled="disabled" @click="$emit('click')">
    <slot>
      <i v-if="icon" class="mr-2" :class="icon" />

      <span>{{ text }}</span>
    </slot>
  </button>
</template>

<script>
// @vuese
// Przycisk
export default {
  props: {
    // Ikona
    icon: { type: String },
    // Tekst
    text: { type: String },
    // Wyłączony
    disabled: { type: Boolean, default: false }
  }
};
</script>
